import { MinusIcon } from '@heroicons/react/24/outline';
import { SVGProps } from 'react';

export function CollapseIcon({
  className = '',
  'aria-hidden': ariaHidden = true,
  ...props
}: SVGProps<SVGSVGElement>) {
  return <MinusIcon className={className} aria-hidden={ariaHidden} {...props} />;
}
